export const ActivateFlowStep = {
	ActivateSim: "ActivateSim",
	RegisterSim: "RegisterSim",
	ConfirmOrUpdatePlan: "ConfirmOrUpdatePlan",
	NextSteps: "NextSteps",
};

export const ActivateFlowStepOrder = {
	[ActivateFlowStep.ActivateSim]: 0,
	[ActivateFlowStep.RegisterSim]: 1,
	[ActivateFlowStep.ConfirmOrUpdatePlan]: 2,
};

export const ActivateFlowOrderSteps = Object.fromEntries(
	Object.entries(ActivateFlowStepOrder).map(([key, value]) => [value, key]),
);
